import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowLeft } from 'react-icons/hi';
import BirthdayCardCreator from './BirthdayCardCreator';

const BirthdayCardCreatorPage = () => {
  return (
    <div className="min-h-screen px-6 relative overflow-hidden">
      {/* Back Button */}
      <div className="mb-8 pt-20">
        <Link 
          to="/birthdays" 
          className="inline-flex items-center text-accent-green hover:text-accent-green/80 transition-colors group"
        >
          <HiArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" />
          Back to Birthday Page
        </Link>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-7">
          <h1 className="text-display-2 font-space-grotesk font-bold gradient-text-green mb-4">
            Create Birthday Card
          </h1>

        </div>

        {/* Birthday Card Creator */}
        <BirthdayCardCreator 
          standalone={true}
        />
      </div>
    </div>
  );
};

export default BirthdayCardCreatorPage;